import webConfig from "web.config.map";

export const InstitutionVoens = webConfig.auth.institutionVoens || {
    STATE_BORDER_SERVICE: "1700360581",
    MINISTRY_OF_EMERGENCY_SITUATIONS: "1300032591",
    MINISTRY_OF_ECOLOGY_AND_NATIONAL_RESOURCES: "1300032591",
    MINISTRY_OF_INTERNAL_AFFAIRS: "",
    ABSHERON_NATIONAL_PARK: "",
    AGGOL_NATIONAL_PARK: "",
    ALTYAGHAJ_NATIONAL_PARK: "",
    GOYGOL_NATIONAL_PARK: "2300328461",
    HIRKAN_NATIONAL_PARK: "",
    GIZILAGHAJ_NATIONAL_PARK: "",
    SAMUR_YALAMA_NATIONAL_PARK: "",
    SHAHDAG_NATIONAL_PARK: "4500671661",
    SHIRVAN_NATIONAL_PARK: "",
    ZANGEZUR_NATIONAL_PARK: "",
    OMINCLOUD: "3104820141",
    DYNAMIC_VERSE: "2906654531",
    DYNAMIC_BOX: "2905950551"
}